import { createContext, RefObject } from 'react';
import {
  AiMentionType,
  AIWebPageDetails,
  OrgMemberRole,
  PortalColorSchemas,
  PortalStyleConfig,
  ThemeColors,
  User,
} from '@nx-frontend/shared/types';

export interface OnPageNavigateOptions {
  /**
   * send the user to the given url, ignores any other routing logic
   */
  url?: string;
  /**
   * navigate to the url using router.push
   */
  routeUrl?: string;
}

export interface ChatbotContextValue {
  apiHost: string;
  workspaceId: string;
  sessionId?: string | null;
  portalSettings?: {
    id: string;
    name: string;
    domain: string;
    hasCustomizerAccess: boolean;
  };
  workspaceSettings?: {
    title: string;
    logo?: {
      storedFileUUID: string;
    };
    color: string;
  };
  /**
   * Flag that the org does not have any subscriptions
   */
  isFreePlan?: boolean;
  /**
   * Sign the the current user is the owner of the current org
   */
  isOrgOwner?: boolean;
  user?: User;
  onShowUpgradePopup: () => void;
  onShowAddonPopup: () => void;
  onPageNavigate: (
    type: AiMentionType | 'workspace' | 'portal' | 'tasks',
    globalId: string,
    options?: OnPageNavigateOptions
  ) => void;
  /**
   * If it is set, it means that the chatbot is opened in the portal
   */
  portalId?: string;
  /**
   * whether current user is a portal visitor
   */
  isVisitor?: boolean;
  role?: { role: OrgMemberRole | 'visitor' };
  apiHostCreateMessage?: string;
  agentId?: string;
  /**
   * if set, then on opening agent mode open an existing thread instead of running an agent
   */
  openExistingAgentThread?: boolean;
  orgId?: string;
  themeColors?: {
    schema: PortalColorSchemas;
    colors: ThemeColors;
  }[];
  themeStyle?: PortalStyleConfig;
  webPageDetails?: AIWebPageDetails;
  pageMode?: boolean;
  isEmbedded?: boolean;
}
export const ChatbotContext = createContext<ChatbotContextValue>({
  workspaceId: '',
  apiHost: '',
  sessionId: '',
  onShowUpgradePopup: () => null,
  onShowAddonPopup: () => null,
  onPageNavigate: () => null,
});

export const MentionsInputContext = createContext<{ textInputRef?: RefObject<HTMLTextAreaElement | null> }>({});
